module.exports = __webpack_public_path__ + "static/media/background1.86254682.jpg";